import React, { Component, Fragment } from 'react'
import { computed, action, observable } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'
import withAppStore from 'decorators/withAppStore'
import formField from 'helpers/formField'
import inject from 'helpers/inject'

import Dialog, { DialogActions, DialogContent, DialogTitle } from 'material-ui/Dialog'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import FormInput from 'components/forms/FormInput'
import AsyncButton from 'components/AsyncButton'
import TextField from 'material-ui/TextField'

import RouterService from 'services/router'

import createApiKey from 'tasks/createApiKey'

import styles from 'styles/components/CreateKeyModal'

@withStyles(styles)
@withAppStore
@observer
export default class CreateKeyModal extends Component {

  router = inject(RouterService)

  @observable key = null

  domainsList = formField({
    value: '',
    label: 'Список доменов',
    name: 'domains',
    validations: {
      presence: true
    }
  })

  @computed
  get service() {
    return this.appStore.createKeyService
  }

  @computed
  get isOpen() {
    return !!this.service
  }

  render() {
    const { classes } = this.props

    return (
      <Dialog
        open={ this.isOpen }
        onClose={ this.handleClose }
      >
        { this.isOpen &&
          <Fragment>
            <DialogTitle>Создание ключа</DialogTitle>
            <DialogContent>
              <Typography paragraph >
                <span className={ classes.bold }>Услуга:</span> { this.service.name }
              </Typography>
              { this.key ? (
                <Fragment>
                  <TextField
                    disabled
                    value={ this.key.key }
                    label="Ваш ключ"
                    fullWidth
                  />
                  <Typography type='caption' >
                    Вы можете получить доступ к ключу в любое время в разделе "Мои ключи"
                  </Typography>
                </Fragment>
              ) : (
                <Fragment>
                  <Typography paragraph type='caption' >
                    Для создания ключа укажите домены, на которых он будет использоваться, разделяя их запятыми.
                  </Typography>
                  <FormInput
                    field={ this.domainsList }
                    TextFieldProps={{
                      fullWidth: true
                    }}
                  />
                </Fragment>
              )}
            </DialogContent>
            <DialogActions className={ classes.actions }>
              <Button onClick={ this.handleClose } color="primary" >
                Закрыть
              </Button>
              { this.key ? (
                <Button onClick={ this.handleKeysClick } color="primary" >
                  Мои ключи
                </Button>
              ) : (
                <AsyncButton
                  action={ this.handleCreate }
                  label='Создать'
                  processingLabel='Создаем...'
                  successLabel='Ключ создан!'
                  ButtonProps={{
                    raised: true,
                    color: 'primary'
                  }}
                />
              )}
            </DialogActions>
          </Fragment>
        }
      </Dialog>
    )
  }

  @action.bound
  handleClose() {
    this.key = null
    this.appStore.createKeyService = null
  }

  @action.bound
  handleKeysClick() {
    this.router.transitionTo(`/keys/${this.key.id}`)
    this.handleClose()
  }

  @action.bound
  async handleCreate() {
    this.domainsList.validate()
    if (this.domainsList.hasErrors) throw new Error()
    const domains = this.domainsList.value
    const service_type = this.service.id
    this.key = await createApiKey.perform({ domains, service_type })
  }

}



// WEBPACK FOOTER //
// ./src/components/CreateKeyModal.js